import React from "react";
import { Reactangle } from "./Reactangle";
import leftbar from "../../assets/images/leftbar.png";
import rightbar from "../../assets/images/rightbar.png";
import { HomeInfo, LeaderTalk, SystemInfo } from "../../models/system";
export class About extends React.Component {

    render(): React.ReactNode {
        let content = {} as HomeInfo;
        if (window.sessionStorage.getItem("sysinfo") != null) {
            content = JSON.parse(window.sessionStorage.getItem("sysinfo")!);
        }
        return (
         
            <>
                <div>
                  
                 
                    <p className="about">{content.aboutUs}</p>


                </div>

            </>
        )
    }
}